import { Box, Grid, Popover, Stack, Typography } from '@mui/material';
import { generateClient } from 'aws-amplify/api';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Schema } from '../../../../../../amplify/data/resource';
import ContactItem from './ContactItem';
import EditContact from './EditContact';

// @ts-ignore
type Contact = Schema['Contact']['type'];

interface Props {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
}

const apiClient = generateClient<Schema>();

const Contacts: React.FC<Props> = ({ open, anchorEl, onClose }) => {
  const { uuid } = useParams<{ uuid: string }>();

  const [contacts, setContacts] = useState<Contact[]>([]);

  const [dialogOpen, setDialogOpen] = useState(false);

  useEffect(() => {
    const fetchContacts = async () => {
      try {
        const subscription = apiClient.models.Contact.observeQuery({
          filter: { userId: { eq: uuid } },
        }).subscribe({
          next: ({ items }: { items: any[] }) => {
            console.log('fetchFiles:next:', items);
            setContacts(items);
          },
          error: (error: any) => {
            console.error('Error fetching clients:', error);
          },
        });

        return () => subscription.unsubscribe();
      } catch (error) {
        console.error('Error during fetchUsers:', error);
      }
    };

    fetchContacts();
  }, [uuid]);

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      PaperProps={{
        sx: {
          maxWidth: '850px',
          boxShadow: '0px 0px 10px 0px #00000026',
          borderRadius: '15px',
          overflow: 'hidden',
        },
      }}
    >
      <Stack spacing={1} sx={{ px: '40px', py: '20px' }}>
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          justifyContent="flex-start"
        >
          <img
            alt="logo"
            src={'/assets/client/add.svg'}
            style={{ cursor: 'pointer', width: '35px', height: '35px' }}
            onClick={() => setDialogOpen(true)}
          />
          <Typography fontWeight="700" fontSize="16px" fontFamily={'AlmoniDL'}>
            הוספת בעל מקצוע
          </Typography>
        </Stack>

        {contacts && (
          <Box
            sx={{
              maxHeight: '300px',
              overflowY: 'auto',
            }}
          >
            <Grid container spacing={1}>
              {contacts.map((contact, index) => (
                <Grid item sm={contacts.length === 1 ? 12 : 6} key={index}>
                  <ContactItem contactItem={contact} userId={uuid || ''} />
                </Grid>
              ))}
            </Grid>
          </Box>
        )}
      </Stack>
      <EditContact
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        userId={uuid || ''}
      />
    </Popover>
  );
};

export default Contacts;
